<template>
    <z-basePage :title="'奖金充值'">
        <div class="search-top">
            <!-- <span>BU名称</span>
            <el-select class="top-choose" v-model="buId" @change="search">
                <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                </z-limitOption>
            </el-select> -->
            
            <div class="back-btn orange" @click="pop.show = true">批量充值</div>
        </div>

        <div class="back-list page">
            <div class="list-head">
                <div>BU名称</div>
                <!-- <div>本期资产(币)</div> -->
                <div>奖金余额({{ task_curr.currency_name }})</div>
                <div>操作</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item" v-for="item in data_list" :key="item.id">
                    <div>{{ item.bu_name }}</div>
                    <!-- <div>{{ item.current_currency_balance_yuan }}</div> -->
                    <div>{{ item.current_currency_balance }}</div>
                    <div class="orange-text" @click="link(item.bu_id)">充值</div>
                </div>
                <z-noData :list="data_list"></z-noData>
            </z-scrollDiv>
        </div>

        <z-windowPop :show="pop.show" :title="pop.title" 
        :noBtns='true' :width="'900px'" @cancel="closePop" v-form="'back-bonus-all'">
            <div class="back-list pop-list">
                <div class="list-head">
                    <div>BU名称</div>
                    <div>奖金余额({{ task_curr.currency_name }})</div>
                    <div>充值金额</div>
                </div>
                <z-scrollDiv class="main">
                    <div class="list-item"  v-for="item in data_list" :key="item.id">
                        <div>{{ item.bu_name }}</div>
                        <div>{{ item.current_currency_balance }}</div>
                        <el-input class="recharge-value" v-model="pop.bu_list[item.bu_id]" v-tar="pop.bu_list[item.bu_id]" rule="noTip_number"></el-input>
                    </div>
                    <!-- <z-noData :list="data_list"></z-noData> -->
                </z-scrollDiv>
            </div>
            <div class="pop-remark">
                <div class="title">备注</div>
                <div class="area">
                    <el-input 
                        type="textarea" 
                        :rows="4"
                        resize="none"
                        placeholder="请输入备注信息"
                        v-tar="pop.remark"
                        rule="noVal"
                        v-model="pop.remark">
                    </el-input>
                </div>
                <div class="btns">
                    <div class="back-btn orange" @click="rechargeAll">完成充值</div>
                    <div class="back-btn" @click="closePop">取消</div>
                </div>
            </div>
        </z-windowPop>
    </z-basePage>
</template>

<script>
    import { mapState,mapGetters } from "vuex"

    export default {
        data(){
            return {
                // buId:"",   //bu id
                data:[],   //获取的数据
                pop:{
                    show:false,
                    title:"奖金批量充值",
                    bu_list:{},
                    remark:"管理员批量调整奖金",
                }
            }
        },
        computed:{
            // ...mapState(["bu_list"]),
            ...mapGetters(['task_curr']),
            data_list(){
                return this.data.filter(item=>{
                    return item.currency_type != 20;
                })
            },
        },
        created(){
            // this.$func.getBuList(true,list=>{
            //     this.buId = list[0] && list[0].id;
            // });
            this.getData();
        },
        methods:{
            getData(){
                // let url = `api/admin/currency_balance_detail/${id || this.buId}`;
                let url = `api/admin/all_currency_balance_detail/list`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });
            },

            link(id){  //进入充值页面
                let str = this.$crypto.encrypt(id);
                this.$router.push({
                    name:'back-finance-assets-add',
                    params:{
                        id:str
                    }
                })
            },

            closePop(){  //关闭弹窗
                this.$form.clear("back-bonus-all");
                this.pop.show = false;
                this.pop.bu_list = {};
                this.pop.remark = "管理员批量调整奖金";
            },

            rechargeAll(){  //批量充值
                let res = this.$form.check("back-bonus-all");
                if(!res){
                    return;
                }

                this.$func.loading(true);

                let obj = {};
                for(let key in this.pop.bu_list){
                    obj[key] = parseInt(this.pop.bu_list[key]);
                }

                let url = `api/admin/all_bonus/recharge`;
                this.$http.post(url,{
                    bu_list:obj,
                    remark:this.pop.remark,
                })
                .then(res=>{
                    if(res.status == 200){
                        this.closePop();
                        this.getData();
                        this.successTip('批量充值成功');
                    }
                    this.$func.loading(false);
                })
                .catch(err=>{
                    this.errorTip('出错了');
                    this.$func.loading(false);
                })

            },
        },
    }
</script>

<style lang="less" scoped>
    // .search-top{
    //     margin-bottom: 10px;
    //     .back-btn{
    //         position: relative;
    //         display:inline-block;
    //         margin-left:25px;
    //     }
    // } 

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 30%;
        }
        >div:nth-of-type(2){
            width: 30%;
        }
        >div:nth-of-type(3){
            width: 10%;
            cursor: pointer;
        }
    }
</style>




// WEBPACK FOOTER //
// page-bonus-recharge.vue?6d84f086